// extracted by mini-css-extract-plugin
export default {"errorInline":"styles_errorInline__CZqPn"};